<template>
  <section class="primaryInfo">
    <a
      name="home"
      style="
        position: relative;
        top: -420px;
        display: block;
        height: 0;
        overflow: hidden;
      "
    ></a>
    <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
    <section class="information">
      <section class="innerBox">
        <!-- <NewsMenu :isActive="isActive"></NewsMenu> -->
        <!-- <div class="leftMenu">
          <li
            @click="gotoHandle(leftItem.anchorId)"
            :class="[
              'menu-item',
              isActive === leftItem.anchorId ? 'menu-item--active' : ''
            ]"
            v-for="(leftItem, idx) in leftMenus"
            :key="idx"
          >
            {{ leftItem.title }}
          </li>
        </div> -->
        <NewsMenu :isActive="isActive"></NewsMenu>
        <NewsBar></NewsBar>
        <div class="info" :dir="langDir">
          <a
            style="display: block; margin-top: 20px;"
            class="version_label"
            :href="
              curLang == 'ar'
                ? '/news-mar11-2020?lang=en'
                : '/news-mar11-2020?lang=ar'
            "
            >{{ curLang == "ar" ? "English Version" : "النسخة العربية" }}</a
          >
          <div v-show="curLang == 'ar'">
            <h1>
              بيان إعلامي من "ToTok": نداء التعاون الموجه إلى "آبل" و"جوجل"
            </h1>

            <!-- <span class="sub_date">Mar 11, 2020</span> -->

            <p>
              <br /><strong>البيان:</strong>

              <br /><br />تم إطلاق تطبيق "ToTok" بهدف تسهيل تواصل المستخدمين مع
              أصدقائهم وزملائهم وعائلاتهم حول العالم. وعلى الرغم من الإدعاءات
              الباطلة والمضللة التي ساقتها بعض وسائل الإعلام مؤخراً، تلقى
              "ToTok" سيلاً من عبارات الدعم والثقة من عشرات الملايين من
              المستخدمين بمن فيهم أكثر من 20 مليون شخص ما زالوا يستخدمون التطبيق
              بانتظام. <br /><br />وفي ذلك رسالةٌ نتوجه بها إلى مستخدمينا
              والعالم أجمع بأن "ToTok" لا يزال قوياً على أي حال.

              <br /><br />وبالرغم من اعتراضنا على إزالة "ToTok" من متجري
              التطبيقات "آب ستور" و"جوجل بلاي"، إلا أننا لم نتردد في إجراء
              التغييرات التي طلبتها شركتا "آبل" و"جوجل" حرصاً منّا على استئناف
              التعاون معهما لإعادة "ToTok" إلى متجري التطبيقات.

              <br /><br />لقد سعت شركتنا وما تزال تسعى إلى الحوار مع "آبل"
              و"جوجل" عبر الاتصال المباشر، وإرسال الرسائل عبر البريد الإلكتروني
              ومواقع التواصل الاجتماعي، ودعوتهما كذلك إلى زيارة مكاتب "ToTok" في
              أبوظبي. ولكننا للأسف لم نتلقَ رداً من "آبل" منذ 7 يناير 2020 ولا
              من "جوجل" منذ 15 فبراير 2020.

              <br /><br />وقد آن الأوان باعتقادنا لاستئناف الحوار والتعاون في ما
              يواجه المجتمع الدولي خطر تفشي فيروس "كورونا" (كوفيد – 19)، ولجوء
              المدارس والجامعات والشركات حول العالم إلى إغلاق أبوابها للمساعدة
              في احتواء المرض. وقد أصبح العمل والتعلم عن بُعد فجأةً النمط الأكثر
              شيوعاً في مناطق عدة حول العالم. وانطلاقاً من قدرات الاتصال الفائقة
              لتطبيقنا بالصوت والصورة، يدعو "ToTok" كلاً من "آبل" و"جوجل" إلى
              التعاون معنا لتيسير سبل التواصل بين الناس حول العالم لا زيادتها
              صعوبةً.

              <br /><br />نود كذلك أن نؤكد لمستخدمينا الكرام والمجتمع الدولي
              كافة بأن تطبيقنا آمن للاستخدام وسيبقى مجانياً للجميع.

              <br /><br />إن "ToTok" هي شركة تجارية مستقلة أسسها عدد من رواد
              الأعمال والمهندسين المقيمين في دولة الإمارات العربية المتحدة؛ وهي
              ما تزال ملتزمةً تماماً بحماية خصوصية وأمن مستخدميها، مع العلم أن
              جميع بيانات المستخدمين مشفّرة بدرجة عالية، كما أن جميع قنوات
              الإرسال محمية تماماً. ويعتمد "ToTok" نفس تقنيات الخصوصية والأمان
              التي تستخدمها تطبيقات المراسلة الرائدة عالمياً بما في في ذلك "واتس
              أب" و"تيليجرام" و" فيسبوك مسنجر"، حتى أن "ToTok" يطلب من مستخدميه
              الوصول إلى مستوىً أقل من البيانات الشخصية بالمقارنة مع "واتس أب"
              و"تيليجرام" و"سيجنال".

              <br /><br />وحتى يعود "ToTok" مجدداً إلى متجري التطبيقات "آب ستور"
              و"جوجل بلاي"، يتوفر التطبيق حالياً للتحميل على الأجهزة العاملة
              بنظام أندرويد عبر الموقع الإلكتروني الرسمي للشركة (<a
                href="https://totok.ai/download-android"
                >https://totok.ai/download-android</a
              >) ، وكذلك عبر متاجر التطبيقات الخاصة بشركات "هواوي", “سامسونج”
              و"شاومي" و"أوبو" و"فيفو"، أو عن طريق المتاجر المستقلة مثل Apkpure،
              وUpToDown، وAptoide، وGetJar، وSoftonic. <br /><br /><span
                style="width: 100%; display: flex; justify-content: center;"
                >- انتهى -</span
              ><br /><br />

              <strong>حول "ToTok"</strong><br /><br />
              تم إطلاق تطبيق "ToTok" في عام 2019 من قبل مجموعة من رواد الأعمال
              العالميين بهدف تسهيل تواصل المستخدمين مع أصدقائهم وزملائهم
              وعائلاتهم حول العالم. ومع توفيره خدمة مجانية وتجربة مستخدمين
              ممتازة، سرعان ما أصبح "ToTok" واحداً من أسرع التطبيقات نمواً في
              العالم، حيث يستخدمه مئات الملايين من الأشخاص.
            </p>
          </div>
          <div v-show="curLang != 'ar'">
            <h1>
              ToTok Media Statement: A Call for Cooperation with Apple and
              Google
            </h1>

            <!-- <span class="sub_date">Mar 11, 2020</span> -->

            <p>
              <br /><strong>STATEMENT:</strong>

              <br /><br />ToTok was built to make it easier for people to
              communicate and connect with their friends, colleagues, and
              families around the world. Despite the misleading and outright
              false accusations carried in certain media outlets recently, ToTok
              has seen an outpouring of support and trust from tens of millions
              of users, including more than 20 million who continue to use the
              app regularly. <br /><br />The message to our users and everyone
              around the world is: ToTok is still going strong.
              <br /><br />While we disagreed with the removal of ToTok from the
              Apple App Store and the Google Play Store, we have implemented
              every specific change requested by both Apple and Google. We
              remain eager to cooperate with the two companies to get ToTok back
              in the app stores for good. <br /><br />Our company has sought and
              continues to seek a dialogue with Apple and Google by calling,
              emailing, and reaching out on social media, inviting the two
              companies to visit the ToTok office in Abu Dhabi. Regrettably,
              there has been no return communications from Apple since January
              7, 2020 and from Google since February 15, 2020. <br /><br />The
              time to resume dialogue and cooperation is now. As the global
              community battles the widespread outbreak of coronavirus
              (COVID-19), schools, universities, and offices around the world
              are closing to help contain the virus. Teleworking and remote
              learning have suddenly become the norm in many parts of the world.
              As an app with superior audio and video capabilities, ToTok calls
              on Google and Apple to work with us to make it easier, not harder,
              for people around the world to communicate. <br /><br />We would
              also like to assure our users, and the global community, that our
              app is secure, safe to use, and remains free for everyone.
              <br /><br />Led by a group of international entrepreneurs and
              engineers working in the UAE, ToTok is an independent commercial
              entity that remains fully committed to protecting our user privacy
              and security. All ToTok user data is strongly encrypted and all
              transmission channels are fully protected. ToTok uses the same
              privacy and security technologies as some of the world’s leading
              messaging apps, including WhatsApp, Telegram, and Facebook
              Messenger. In fact, ToTok asks its users for access to less of
              their data than WhatsApp, Telegram, and Signal. <br /><br />Until
              ToTok is back on the Google Play Store and the Apple App Store,
              the app remains available for download to Android users on ToTok’s
              official website (<a href="https://totok.ai/download-android"
                >https://totok.ai/download-android</a
              >), through the Huawei, Samsung, Xiaomi, Vivo app stores, or via
              popular third-party stores such as Apkpure, UpToDown, Aptoide,
              GetJar, Softonic. <br /><br /><span
                style="width: 100%; display: flex; justify-content: center;"
                >--END--</span
              ><br />
            </p>

            <p><strong>About ToTok</strong></p>
            <p>
              ToTok was launched in 2019 by a group of international
              entrepreneurs with the ambition to make it easier for people to
              communicate and connect with their friends, colleagues, and
              families around the world. Providing a free service with superior
              user experience, it quickly became one of the fastest-growing apps
              in the world, and is used today by tens of millions of people.
            </p>
          </div>
        </div>
      </section>
    </section>
    <Footer></Footer>
    <FootBanner></FootBanner>
  </section>
</template>

<script>
import queryString from "query-string";
import NewsBar from "@/components/NewsBar.vue";
import NavCrumbs from "@/components/NavCrumbs.vue";
import NewsMenu from "@/components/NewsMenu.vue";
import FootBanner from "@/components/FootBanner.vue";
import Footer from "@/components/Footer.vue";
export default {
  metaInfo() {
    return {
      title:
        "ToTok Media Statement: A Call for Cooperation with Apple and Google",
      // meta: [{
      //     vmid: 'og:title',
      //     property: 'og:title',
      //     name: 'og:title',
      //     content: 'Terms of Use - ToTok Messenger',
      // },{
      //     vmid:"og:description",
      //     property: 'og:description',
      //     name: 'og:description',
      //     content: 'Enjoy FREE, FAST and FUN calling with your family and friends.'
      // },]
      meta: [
        {
          property: "og:title",
          content:
            "ToTok Media Statement: A Call for Cooperation with Apple and Google",
        },
        {
          property: "og:description",
          content:
            "ToTok Media Statement: A Call for Cooperation with Apple and Google",
        },
        { property: "og:url", content: "https://totok.ai/news-mar11-2020" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    NewsBar,
    NavCrumbs,
    NewsMenu,
    Footer,
    FootBanner,
  },
  data() {
    return {
      langDir: "",
      showinfo: false,
      isActive: "newsMar202011",
      crumbProp: {
        label: "Recent News",
        type: "simple",
      },
      leftMenus: [
        {
          title: "Mar 23",
          anchorId: "newsMar202023",
        },
        {
          title: "Mar 11",
          anchorId: "newsMar202011",
        },
        {
          title: "Mar 05",
          anchorId: "newsMar202005",
        },
        {
          title: "Feb 23",
          anchorId: "newsFeb20200223",
        },
        {
          title: "Feb 20",
          anchorId: "Feb202020",
        },
        {
          title: "Jan 05",
          anchorId: "Jan05",
        },
        {
          title: "Dec 29",
          anchorId: "Dec29",
        },
        {
          title: "Dec 27",
          anchorId: "Dec27",
        },
        {
          title: "Dec 24",
          anchorId: "Dec24",
        },
        {
          title: "Dec 23",
          anchorId: "Dec23",
        },
      ],
    };
  },
  computed: {
    info() {
      return [];
    },
    curLang() {
      let lang =
        queryString.parseUrl(location.href) &&
        queryString.parseUrl(location.href).query &&
        queryString.parseUrl(location.href).query.lang
          ? queryString.parseUrl(location.href).query.lang
          : navigator.language == "ar"
          ? "ar"
          : "en";
      this.langDir = lang == "ar" ? "rtl" : "ltr";
      return lang;
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  methods: {
    gotoHandle(palice) {
      console.log("palice", palice);
      switch (palice) {
        case "newsMar202023":
          this.isActive = "newsMar202023";
          this.$router.push({ name: "newsMar202023" });
          break;
        case "newsMar202011":
          this.isActive = "newsMar202011";
          this.$router.push({ name: "newsMar202011" });
          break;
        case "newsMar202005":
          this.isActive = "newsMar202005";
          this.$router.push({ name: "newsMar202005" });
          break;
        case "newsFeb20200223":
          this.isActive = "newsFeb20200223";
          this.$router.push({ name: "newsFeb20200223" });
          break;
        case "Feb202020":
          this.isActive = "Feb202020";
          this.$router.push({ name: "newsFeb202020" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Jan05":
          this.isActive = "Jan05";
          this.$router.push({ name: "newsJan05" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec29":
          this.isActive = "Dec29";
          this.$router.push({ name: "newsDec29" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec27":
          this.isActive = "Dec27";
          this.$router.push({ name: "newsDec27" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec24":
          this.isActive = "Dec24";
          this.$router.push({ name: "newsDec24" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec23":
          this.isActive = "Dec23";
          // this.$router.push({name:'newsDec22'})
          // this.mainPannel.scrollTo(0, 0)
          this.$router.push({ name: "newsDec22" });
          break;
      }
    },
  },
};
</script>
<style scoped lang="stylus">
 @media only screen and (max-width: 700px) {
    .primaryInfo {
        // padding: 0.8rem;
        background: #fff;
        height: 106vh;
        .innerBox {
            padding-bottom: 50px;
        }
        .leftMenu {
            display none
        }

        div {
            margin-left: 20px;
            margin-right: 20px;
        }

        .info {


            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            h6 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-style: italic;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;

            }
        }
    }

    .cp {
        height: 3.5rem;
        font-size: 13px;
        color: #808080;
        line-height: 3.5rem;
        text-align: center;
    }
}

@media only screen and (min-width: 701px) {
    .primaryInfo {
        padding-top: 102px;
        width: 100vw;
        background: #fff;

        .information {
            margin: 0 auto;
            width: 800px;

            .innerBox {
                position relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
                height: 83vh;
                overflow: auto;


                .leftMenu {
                    position: absolute;
                    left: 0px;
                    top: 39px;
                    display flex;
                    flex-direction column;
                    justify-content center;
                    align-items: flex-start;
                    list-style none;

                    .menu-item {
                        color: #979797;
                        margin-top: 30px;
                        cursor pointer;
                        text-decoration none;
                        font-size: 15px;
                    }

                    .menu-item:nth-child(1) {
                        margin-top: 0px;
                    }

                    .menu-item--active {
                        color: #000;
                        border-bottom: 2px solid #4377f2;
                    }

                }
            }
        }

        .info {
                width: 550px;
            margin: 20px 0;
margin-bottom:60px;
            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            h6 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-style: italic;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }

    .cp {
        height: 70px;
        font-size: 13px;
        color: #808080;
        line-height: 70px;
        text-align: center;
    }
}
</style>
